export namespace GenericDialogTypes {



    export type ButtonPreset = "yesno" | "ok" | "close" | "okcancel" | "yesnocancel" | "saveclose" | "submitcancel" | "deletecancel";

    export type DialogSize = "default" | "smaller" | "larger" | "largest" | "fullsize" | "widest" | "contentBased";

    export const enum DialogIcon {
        "warning" = "fas fa-exclamation-triangle"
    }

    export type DialogPreset = "savePendingChangesYesNo" | "savePendingChangesYesNoCancel" | "confirmUndoPendingChangesYesNo" | "confirmCancelAction" | "confirmAction" | "smallYesNoQuestion" | "smallQuestionSilentNo" | "smallSuccessMessage" | "confirmDelete" | "smallError";


    export interface CallbackConfig {
        yesCallback?: Function,
        noCallback?: Function,
        cancelCallback?: Function,
        okCallback?: Function,
        nextCallback?: Function
        backCallback?: Function,
    }

    export interface DlgAdditionalConfig {
        size?: DialogSize,
        frameColor?: string,
        titleIconClass?: string
        keepOpen?: boolean,
        closeOnEnter?: boolean,
        closeOnEscape?: boolean,
        additionalButtons?: Array<ButtonConfig>
        distinctiveNoCallback?: Function | "silentclose",
        callbackConfig?: GenericDialogTypes.CallbackConfig
    }

    interface ButtonConfig {
        internalName: string,
        label: translatableString,
        callback: Function,
        tooltip?: translatableString,
        styleClass?: "primary" | "secondary" | "tertiary",
        iconClass?: string,
        bCloseOnClick?: boolean,
        position?: "first" | "last" | "left first" | "left last" | "top" | "top first" | "top last" | number,
        enabled?: boolean
    }

    export interface DlgConfig extends DlgAdditionalConfig {
        content: translatableString | HTMLElement | dijit._WidgetBase,
        subtitle?: translatableString,
        header?: translatableString,
        contentIconClass?: string | GenericDialogTypes.DialogIcon,
        buttonPreset?: ButtonPreset,
        callback?: Function,
        callbackConfig?: CallbackConfig
    }



    export const enum GenericDialogResult {
        "ok" = 1,
        "delete" = 1,
        "cancel" = 0,
        "no" = -1,
        "close" = 0,
        "yes" = 2,
        "next" = 3,
        "back" = 4
    }
}
